/** Bókun's module for the easy flow: its words. Its credential fields (the access key and the
 *  secret key of a REST API key) come from the backend with their labels and hints; the console
 *  offers only these keys, never "Connect with Bókun". */
import type { EasyRestechModule } from '../registry';

export const BOKUN: EasyRestechModule = {
  code: 'bokun',
  vendor: 'Bókun',
  products: 'products',
  // On the keys path the operator adds our webhook in Bókun's own settings.
  webhookSetup: 'manual',
};
